import { Burger } from '../core'

export default {
  burger: undefined,

  init() {
    /* Burger */
    let obj = this
    obj.burger = new Burger('.burger', {
      onToggle: function() {
        if (obj.burger.isExpanded) {
          $('body').addClass('--menu-open --no-scroll')
          $('.header__burger-wrapper').addClass('--white')
          $('.burger').attr('aria-expanded', 'true');
        } else {
          $('.burger').attr('aria-expanded', 'false');
          $('body').removeClass('--menu-open --no-scroll --open-directors-desktop --open-directors-mobile')
          $('.header__burger-wrapper').addClass('--black')
          $('.header__burger-wrapper').removeClass('--white')
          setTimeout(function() {$('.header__burger-wrapper').removeClass('--black')}, 700);
        }
      },
    })

    $('.js-open-contact').click(function () {
      $('body').addClass('--open-contact');
      $('.header__main').animate({scrollTop: $('.header__main__wrapper').innerHeight()}, 'slow');
      $('body').removeClass('--open-directors-mobile');
    })

    $('.js-close-contact').click(function () {
      $('body').removeClass('--open-contact');
    })

    $('.directors-toggle').click(function () {
      $('body').addClass('--open-directors-desktop');
      $('.burger').attr('aria-expanded', 'true');
    })

    $('.header__directors').each(function () {
      var link_label = $(this).find('.header__directors__title').html();
      var new_link = $('<li class="main-menu__item mobile-only js-mobile-directors-toggle"><a class="main-menu__link over-target"><span>' + link_label + '</span></a></li>');
      $('.main-menu').append(new_link);
      $('.js-mobile-directors-toggle').append($('.directors-menu').clone());
    })

    $('.js-mobile-directors-toggle').click(function () {
      $('body').removeClass('--open-contact');
      if (!$('body').hasClass('--open-directors-mobile')) {
        $('.header__main').animate({scrollTop: $('.header__main__wrapper').innerHeight()}, 'slow');
      }
      $('body').toggleClass('--open-directors-mobile');
    })

    obj.resize();

    $(window).on('resize load orientationchange', obj.resize)
  },

  resize() {
    $('.js-mobile-directors-toggle').each(function() {
      $(this).find('.directors-menu').css('--max-height', $(this).find('.directors-menu__names').innerHeight() +  'px')
      var footer_height = $('.header__footer').innerHeight();
      var directors_height = $('.directors-menu__names').innerHeight() + 80;
      var min_height = footer_height;
      if (directors_height > footer_height) {
        var min_height = directors_height;
      }
      $('.header').css('--min-spacing', min_height + 'px');
      $('.header').css('--directors', directors_height + 'px');
      $('.header').css('--contact', footer_height + 'px');
      $('.header').removeClass('--limited-height');
      var menu_height = $('.header__main .main-menu').innerHeight() + min_height
      var max_menu_height = $('.header__main').innerHeight()
      if (max_menu_height < menu_height) {
        $('.header').addClass('--limited-height');
      } else {
        $('.header').removeClass('--limited-height');
      }
    });
  },
}
